
  



async function addToCart(item) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  });
  if (!response.ok) throw new Error("Failed to add item to cart");
  return response.json();
}

  
  let toastShown = false;
function showToast(message, type = 'success') {

  if(!toastShown){
toastShown=true;
    const toastContainer = document.getElementById('toast-container');
    
    // Create toast element
    const toast = document.createElement('div');
    toast.classList.add('toast', type); // Directly add the type as a class

    toast.innerText = message;

    // Append the toast to the container
    toastContainer.appendChild(toast);

    // Remove the toast after the animation
    setTimeout(() => {
      toastShown=false;
       toast.remove();
    }, 4000); // Match the animation duration
  }
}

  
function showModal() {
    document.getElementById('addonModal').style.display = 'flex';
    document.documentElement.classList.add('overflow-hidden'); // Disable scroll on <html>
}

function closeModal() {
    document.getElementById('addonModal').style.display = 'none';
    document.documentElement.classList.remove('overflow-hidden'); // Re-enable scroll on <html>
}
  async function skipModal() {
  try {
    // 🔹 Fetch the latest cart data from Shopify
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      console.error("Failed to fetch cart data");
      return;
    }

    const cartData = await response.json();

    // 🔹 Optional: Check if the cart is empty or the item is added
    if (cartData.items.length > 0) {
      console.log("Items found in the cart:", cartData.items);

      // 🔹 Adding a slight delay to ensure Shopify syncs properly
      setTimeout(() => {
        window.location.href = '/cart';
      }, 500); // 500ms delay
    } else {
      console.warn("Cart is still empty, retrying...");

      // 🔹 Retry fetching after a delay
      setTimeout(skipModal, 500); // Try again after 500ms
    }

  } catch (error) {
    console.error("Error fetching updated cart:", error);
  }
}

async function updateCartCount() {
    await fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartCount = cart.item_count;
            const cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) {
                cartIcon.textContent = cartCount;
            }
        })
        .catch(error => console.error('Error updating cart count:', error));
}

    const checkboxes = document.querySelectorAll('.addon-checkbox');
    const skipButton = document.querySelector('.close-modal');
    const selectedItemsInfo = document.querySelector('.selected-items-info');

    function updateSelectedInfo() {
        const selectedItems = Array.from(checkboxes).filter(checkbox => checkbox.checked);
        const totalPrice = selectedItems.reduce((total, checkbox) => {
            return total + parseFloat(checkbox.getAttribute('data-product-price').replace(/[^0-9.-]+/g, "")); // Assuming price is in a format like "$299.99"
        }, 0);
        
        if (selectedItems.length > 0) {
            skipButton.classList.add('hidden'); // Hide "Skip" button
            skipButton.style.display='none';  
            selectedItemsInfo.classList.remove('hidden'); // Show selected items info
            selectedItemsInfo.style.display = 'block'; // Ensure it is visible
            selectedItemsInfo.innerHTML = `${selectedItems.length} item(s) <br> Total: <span class='boldPrice'> ₹${totalPrice.toFixed(2)} </span> `;
        } else {
            skipButton.style.display='block';  
            skipButton.classList.remove('hidden'); // Show "Skip" button
            selectedItemsInfo.style.display = 'none'; // Completely hide it
            selectedItemsInfo.classList.add('hidden'); // Hide selected items info
        }
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            const label = this.nextElementSibling;
            const addedInfoContainer = label.nextElementSibling; // This now targets the div with both 'added-text' and 'remove'
            const addedText = addedInfoContainer.querySelector('.added-text');
            const removeText = addedInfoContainer.querySelector('.remove');

            if (this.checked) {
                label.style.display = 'none';
                addedText.style.display = 'inline';
                removeText.style.display = 'inline';
                  addedInfoContainer.style.display='block'
              

                // Add an event listener for the 'X' button to remove the item
                removeText.addEventListener('click', function() {
                    checkbox.checked = false;
                    label.style.display = 'inline';
                    addedText.style.display = 'none';
                    removeText.style.display = 'none';
                  addedInfoContainer.style.display='none'
                  
                    updateSelectedInfo(); // Update info when unchecked
                });
            } else {
                  addedInfoContainer.style.display='none'
              
                label.style.display = 'inline';
                addedText.style.display = 'none';
                removeText.style.display = 'none';
            }

            updateSelectedInfo(); // Update info on change
        });
    });



// Function to add selected items to the cart
async function addSelectedToCart() {
  // Get the Continue button and its elements
  const continueButton = document.querySelector('.continue-modal');
  const buttonText = continueButton.querySelector('.button-text');
  const loadingSpinner = continueButton.querySelector('.loading__spinner');

  // Show the loading spinner and disable the button
  buttonText.classList.add('hidden');
  loadingSpinner.classList.remove('hidden');
  continueButton.setAttribute('disabled', true);

  const selectedItems = [];

  document.querySelectorAll('.addon-checkbox:checked').forEach(checkbox => {
    const productId = checkbox.getAttribute('data-product-id');
    const quantity = 1; // Default quantity is 1 for each item
    selectedItems.push({
      id: productId,
      quantity: quantity,
    });
  });

  if (selectedItems.length > 0) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: selectedItems })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Selected products added to cart:', data);
        window.location.href = '/cart';
    })
    .catch(error => {
      showToast('Something went wrong', 'error');
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      buttonText.classList.remove('hidden');
      loadingSpinner.classList.add('hidden');
      continueButton.removeAttribute('disabled');
    });
  } else {
        try {
      // 🔹 Fetch the latest cart data from Shopify
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });
  
      if (!response.ok) {
        console.error("Failed to fetch cart data");
        return;
      }
  
      const cartData = await response.json();
  
      // 🔹 Optional: Check if the cart is empty or the item is added
      if (cartData.items.length > 0) {
        console.log("Items found in the cart:", cartData.items);
  
        // 🔹 Adding a slight delay to ensure Shopify syncs properly
        setTimeout(() => {
          window.location.href = '/cart';
        }, 500); // 500ms delay
      } else {
        console.warn("Cart is still empty, retrying...");
  
        // 🔹 Retry fetching after a delay
        setTimeout(skipModal, 500); // Try again after 500ms
      }
  
    } catch (error) {
      console.error("Error fetching updated cart:", error);
    }
  
  }
}
